import { render, staticRenderFns } from "./ModalSetSchoolCurriculum.vue?vue&type=template&id=37b8e433&scoped=true&lang=pug&"
import script from "./ModalSetSchoolCurriculum.vue?vue&type=script&lang=ts&"
export * from "./ModalSetSchoolCurriculum.vue?vue&type=script&lang=ts&"
import style0 from "./ModalSetSchoolCurriculum.vue?vue&type=style&index=0&id=37b8e433&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b8e433",
  null
  
)

export default component.exports